import { useContext } from 'react';
import { useMutation, useQuery } from '@tanstack/react-query';
import { gql } from 'graphql-request';
import { SkillsClientContext } from 'components/shared/Skills/SkillsClientProvider';

export function useGetGlobalSkillsSettings() {
  const { client } = useContext(SkillsClientContext);

  return useQuery(['skillsSettings'], async () => {
    return client.request(
      gql`
        query {
          skillsSettings {
            ratingDefinitions {
              one
              two
              three
              four
              five
            }
            ratingIconStyle
            ratingScale
          }
        }
      `,
    );
  });
}

export function useUpdateGlobalSkillsSettings() {
  const { client } = useContext(SkillsClientContext);
  return useMutation({
    mutationFn: variables =>
      client.request(
        gql`
          mutation updateCompanySettings(
            $ratingIconStyle: String!
            $ratingDefinitions: String!
            $ratingScale: Int
          ) {
            updateCompanySettings(
              ratingIconStyle: $ratingIconStyle
              ratingDefinitions: $ratingDefinitions
              ratingScale: $ratingScale
            ) {
              ratingIconStyle
              ratingDefinitions {
                one
                two
                three
                four
                five
              }
              ratingScale
              skillsSetupState
            }
          }
        `,
        variables,
      ),
  });
}
